
import { timeout } from '/js🧠🧠🧠/defaults/math🧮.js'
import './index.scss'



class Loader {
  constructor (main,temp,device) {
    
    this.main = main
    this.counter = 0
    this.index = 0
    this.temp = {init:temp,pop:temp}
    this.device = device
    
  }
  async create(){
    document.querySelector('body').insertAdjacentHTML('afterbegin',this.temp.init)
    
    this.DOM = {
      el: document.documentElement.querySelector('.loader'),
      
    }

    this.createAnim()
  }
  
  createAnim(){
    this.anim = new Interpol({
      paused:true,
      duration:1200,
      props: {
        x: [-100, 0, "%"],
        opacity: [1, 0],
      },
      onUpdate: ({ x, opacity }) => {
        this.DOM.el.style.opacity = opacity
      },
    
    })
   
  }
  

  async hide(){

  }
  async show(){
  }
  async start () {

    this.anim.play()
  }

  async showPop(){

    if(this.device > 1){
      
    }
  }

  async hidePop(){
    if(this.device > 1){
      this.DOM.el.remove()
    }
  }

  async hideIntro(template = ''){


    this.anim.seek(1)
    
   
  }

}

export default Loader
